import bingoQuery from './index.vue';
export default bingoQuery;



// WEBPACK FOOTER //
// ./src/components/bingo-query/index.js